module.exports = __webpack_public_path__ + "static/media/balance_1000000_3000000.12cd0196.png";